import type { LevelDef } from '../sim/level/schema';

/** The hull stays solid; masts, rigging and cargo are scenery rather than body traps. */
export const pirateBlackSail: LevelDef = {
  id: 'pirate-black-sail',
  name: 'Black Sail',
  theme: 'pirate',
  bounds: { x: 0, y: 0, w: 28, h: 16 },
  killMargin: 6,
  spawns: [{ x: 5, y: 6.1 }, { x: 23, y: 6.1 }, { x: 10, y: 3.5 }, { x: 18, y: 3.5 }],
  drops: { enabled: true, xMin: 3, xMax: 25, intervalScale: 1 },
  objects: [
    { type: 'solid', x: 14, y: 1, w: 28, h: 2 },
    { type: 'solid', x: 5, y: 4.4, w: 8, h: 0.4 },
    { type: 'solid', x: 23, y: 4.4, w: 8, h: 0.4 },
    { type: 'solid', x: 14, y: 7, w: 5, h: 0.4 },
    // Cannon fire crosses the raised decks. The entire lower deck is sheltered beneath it.
    { type: 'cannon', x: 1.7, y: 5.4, dir: 'right', speed: 12, period: 360, delay: 0, warningTicks: 60 },
    { type: 'cannon', x: 26.3, y: 5.4, dir: 'left', speed: 12, period: 360, delay: 180, warningTicks: 60 },
  ],
  decor: [
    { kind: 'pirate-sea', x: 14, y: 0.4, scale: 1 },
    { kind: 'pirate-island', x: 3, y: 3.3, scale: 0.9 },
    { kind: 'pirate-island', x: 27, y: 2.7, scale: 1.1 },
    { kind: 'pirate-hull', x: 14, y: 2, scale: 1 },
    { kind: 'pirate-mast', x: 14, y: 2, scale: 1 },
    { kind: 'pirate-rigging', x: 14, y: 2, scale: 1 },
    { kind: 'pirate-lantern', x: 4.5, y: 7.4, scale: 0.85 },
    { kind: 'pirate-lantern', x: 23.5, y: 7.4, scale: 0.85 },
  ],
};

/** Three broad piers share a permanent lower dock, so a broken weapon or fallen body cannot cut the route. */
export const pirateSmugglersDock: LevelDef = {
  id: 'pirate-smugglers-dock',
  name: "Smuggler's Dock",
  theme: 'pirate',
  bounds: { x: 0, y: 0, w: 36, h: 18 },
  killMargin: 6,
  spawns: [
    { x: 1, y: 3.5 }, { x: 35, y: 3.5 },
    { x: 7.5, y: 6.1 }, { x: 28.5, y: 6.1 },
    { x: 11.5, y: 3.5 }, { x: 24.5, y: 3.5 },
    { x: 14.8, y: 6.1 }, { x: 21.2, y: 6.1 },
  ],
  drops: { enabled: true, xMin: 3, xMax: 33, intervalScale: 0.9 },
  objects: [
    { type: 'solid', x: 18, y: 1, w: 36, h: 2 },
    { type: 'solid', x: 6, y: 4.4, w: 8, h: 0.4 },
    { type: 'solid', x: 18, y: 4.4, w: 10, h: 0.4 },
    { type: 'solid', x: 30, y: 4.4, w: 8, h: 0.4 },
    { type: 'solid', x: 18, y: 7, w: 4, h: 0.4 },
    { type: 'cannon', x: 2.7, y: 5.4, dir: 'right', speed: 12, period: 420, delay: 0, warningTicks: 60 },
    { type: 'cannon', x: 33.3, y: 5.4, dir: 'left', speed: 12, period: 420, delay: 210, warningTicks: 60 },
  ],
  decor: [
    { kind: 'pirate-sea', x: 18, y: 0.4, scale: 1.3 },
    { kind: 'pirate-island', x: 1, y: 4, scale: 1.2 },
    { kind: 'pirate-island', x: 35, y: 3.1, scale: 1 },
    { kind: 'pirate-dock', x: 18, y: 2, scale: 1 },
    { kind: 'pirate-mast', x: 18, y: 2, scale: 1.2 },
    { kind: 'pirate-rigging', x: 18, y: 2, scale: 1.2 },
    { kind: 'pirate-warehouse', x: 6, y: 2, scale: 0.9 },
    { kind: 'pirate-warehouse', x: 30, y: 2, scale: 0.9 },
    { kind: 'pirate-lantern', x: 10.5, y: 8.2 },
    { kind: 'pirate-lantern', x: 25.5, y: 8.2 },
  ],
};

export const PIRATE_ARENAS: LevelDef[] = [pirateBlackSail, pirateSmugglersDock];
